
module.exports = {
  "colors": {
    
      "baseCoral":  "#ff5c39",
    
      "baseRed":  "#dc2222",
    
      "baseGold":  "#d6cf8d",
    
      "baseGreen":  "#3ba150",
    
      "baseNavy":  "#001e62",
    
      "basePink":  "#ff808b",
    
      "baseTeal":  "#00a5ad",
    
      "baseYellow":  "#ffb500",
    
      "grey10":  "#f8f8f8",
    
      "grey30":  "#e0e0e0",
    
      "grey50":  "#bebebe",
    
      "grey70":  "#707070",
    
      "grey90":  "#3b3b3b",
    
      "transparentLight":  "rgba(255,255,255,0.6)",
    
      "transparentDark":  "rgba(0,0,0,0.6)",
    
      "white":  "#fff",
    
      "red10":  "#fff3f0",
    
      "red100":  "#961717",
    
      "coral10":  "#ffeeea",
    
      "coral100":  "#cb3a29",
    
      "gold10":  "#f7f5e6",
    
      "gold100":  "#726d40",
    
      "green10":  "#ecffea",
    
      "green100":  "#37824b",
    
      "navy10":  "#e7efff",
    
      "navy100":  "#0d1e44",
    
      "pink10":  "#fff0f1",
    
      "pink100":  "#c24353",
    
      "teal10":  "#e6f9fa",
    
      "teal100":  "#2f7b84",
    
      "yellow10":  "#fef1d1",
    
      "yellow100":  "#9a6914",
    
      "bloomBaseNavy800":  "#071948",
    
      "bloomBaseBlue600":  "#4036ED",
    
      "bloomBaseCoral600":  "#FF6668",
    
      "bloomBaseTeal600":  "#11C6CF",
    
      "bloomGreen700":  "#008354",
    
      "bloomGreen400":  "#73CFA3",
    
      "bloomGreen100":  "#F1FFF8",
    
      "bloomBasePurple600":  "#8E5AFF",
    
      "bloomBaseYellow600":  "#FFCB4D",
    
      "bloomBasePink600":  "#F89099",
    
      "bloomGreyNavy800":  "#071948",
    
      "bloomGreyNavy700":  "#36456B",
    
      "bloomGreyNavy600":  "#515E7F",
    
      "bloomGreyNavy500":  "#838CA3",
    
      "bloomGreyNavy400":  "#B5BAC8",
    
      "bloomGreyNavy300":  "#E6E8ED",
    
      "bloomGreyNavy200":  "#F3F4F6",
    
      "bloomGreyNavy100":  "#F8F8FA",
    
      "bloomBlue700":  "#2C25A5",
    
      "bloomBlue400":  "#7972F2",
    
      "bloomBlue200":  "#B2AEF7",
    
      "bloomBlue100":  "#EBEAFD",
    
      "bloomCoral700":  "#B24748",
    
      "bloomCoral400":  "#FF9395",
    
      "bloomCoral200":  "#FFC1C2",
    
      "bloomCoral100":  "#FFEFEF",
    
      "bloomTeal700":  "#0B8A90",
    
      "bloomTeal400":  "#58D7DD",
    
      "bloomTeal200":  "#9FE8EB",
    
      "bloomTeal100":  "#E7F9FA",
    
      "bloomYellow700":  "#B28E35",
    
      "bloomYellow400":  "#FFDA82",
    
      "bloomYellow200":  "#FFEAB7",
    
      "bloomYellow100":  "#FFF9ED",
    
      "bloomPink700":  "#B28085",
    
      "bloomPink400":  "#FFCDD1",
    
      "bloomPink200":  "#FFE2E5",
    
      "bloomPink100":  "#FFF7F8",
    
      "bloomPurple700":  "#633EB2",
    
      "bloomPurple400":  "#AF8BFF",
    
      "bloomPurple200":  "#D1BDFF",
    
      "bloomPurple100":  "#F3EEFF",
    
      "bloomOchre700":  "#86640C",
    
      "bloomOchre400":  "#EAB65C",
    
      "bloomOchre100":  "#FDF5EB",
    
      "bloomRed700":  "#D02B0B",
    
      "bloomRed400":  "#FF5641",
    
      "bloomRed100":  "#FDF4F4",
    
      "foundationsBlue1000Light":  "#051230",
    
      "foundationsBlue900Light":  "#0A2460",
    
      "foundationsBlue800Light":  "#0E3591",
    
      "foundationsBlue700Light":  "#1347C1",
    
      "foundationsBlue600Light":  "#1859F1",
    
      "foundationsBlue500Light":  "#467AF4",
    
      "foundationsBlue400Light":  "#749BF7",
    
      "foundationsBlue300Light":  "#A3BDF9",
    
      "foundationsBlue200Light":  "#D1DEFC",
    
      "foundationsBlue100Light":  "#E8EEFE",
    
      "foundationsGrey1000Light":  "#1A253D",
    
      "foundationsGrey800Light":  "#59637A",
    
      "foundationsGrey700Light":  "#626F8C",
    
      "foundationsGrey600Light":  "#808BA6",
    
      "foundationsGrey500Light":  "#949DB2",
    
      "foundationsGrey400Light":  "#B4BBCA",
    
      "foundationsGrey200Light":  "#E4E7F0",
    
      "foundationsGrey100Light":  "#F5F6FA",
    
      "foundationsGreen1000Light":  "#101F06",
    
      "foundationsGreen900Light":  "#1F3E0C",
    
      "foundationsGreen800Light":  "#2F5E12",
    
      "foundationsGreen700Light":  "#3E7D18",
    
      "foundationsGreen600Light":  "#4E9C1E",
    
      "foundationsGreen500Light":  "#6EAF46",
    
      "foundationsGreen400Light":  "#8EC26E",
    
      "foundationsGreen300Light":  "#AFD497",
    
      "foundationsGreen200Light":  "#CFE7BF",
    
      "foundationsGreen100Light":  "#EFFAE7",
    
      "foundationsCoral1000Light":  "#300F05",
    
      "foundationsCoral900Light":  "#611E0A",
    
      "foundationsCoral800Light":  "#912C0E",
    
      "foundationsCoral700Light":  "#C23B13",
    
      "foundationsCoral600Light":  "#F24A18",
    
      "foundationsCoral500Light":  "#F56E46",
    
      "foundationsCoral400Light":  "#F79274",
    
      "foundationsCoral300Light":  "#FAB7A3",
    
      "foundationsCoral200Light":  "#FCDBD1",
    
      "foundationsCoral100Light":  "#FEEDE8",
    
      "foundationsTeal1000Light":  "#022427",
    
      "foundationsTeal900Light":  "#04474E",
    
      "foundationsTeal800Light":  "#076B76",
    
      "foundationsTeal700Light":  "#098E9D",
    
      "foundationsTeal600Light":  "#0BB2C4",
    
      "foundationsTeal500Light":  "#3AC1D0",
    
      "foundationsTeal400Light":  "#6AD0DC",
    
      "foundationsTeal300Light":  "#99E0E7",
    
      "foundationsTeal200Light":  "#C9EFF3",
    
      "foundationsTeal100Light":  "#E0F6F9",
    
      "foundationsYellow1000Light":  "#2D2105",
    
      "foundationsYellow900Light":  "#5A4309",
    
      "foundationsYellow800Light":  "#88640E",
    
      "foundationsYellow700Light":  "#B58612",
    
      "foundationsYellow600Light":  "#E2A717",
    
      "foundationsYellow500Light":  "#E8B945",
    
      "foundationsYellow400Light":  "#EECA74",
    
      "foundationsYellow300Light":  "#F3DCA2",
    
      "foundationsYellow200Light":  "#F9EDD1",
    
      "foundationsYellow100Light":  "#FCF6E8",
    
      "foundationsPink1000Light":  "#401417",
    
      "foundationsPink900Light":  "#6B242A",
    
      "foundationsPink800Light":  "#95353D",
    
      "foundationsPink700Light":  "#C04550",
    
      "foundationsPink600Light":  "#EA5663",
    
      "foundationsPink500Light":  "#EE7882",
    
      "foundationsPink400Light":  "#F29AA1",
    
      "foundationsPink300Light":  "#F7BBC1",
    
      "foundationsPink200Light":  "#FBDDE0",
    
      "foundationsPink100Light":  "#FDEEEF",
    
  },

  "spacings": {
    
      "xxs":  "0.25rem",
    
      "xs":  "0.5rem",
    
      "sm":  "0.75rem",
    
      "md":  "1rem",
    
      "lg":  "1.5rem",
    
      "xl":  "2rem",
    
      "xxl":  "2.5rem",
    
  },

  "spacingsPx": {
    
      "xxs":  4,
    
      "xs":  8,
    
      "sm":  12,
    
      "md":  16,
    
      "lg":  24,
    
      "xl":  32,
    
      "xxl":  40,
    
  },

  "textStyles": {
    
      "footnote":  "0.75rem",
    
      "footnoteHeavy":  "0.75rem",
    
      "caption":  "0.875rem",
    
      "captionHeavy":  "0.875rem",
    
      "body":  "1rem",
    
      "bodyHeavy":  "1rem",
    
      "smHeader":  "1rem",
    
      "mdHeader":  "1.125rem",
    
      "mdHeaderRegular":  "1.125rem",
    
      "lgHeader":  "1.25rem",
    
      "lgHeaderRegular":  "1.25rem",
    
      "xlHeader":  "1.5rem",
    
      "hugeHeader":  "1.75rem",
    
      "smHero":  "2rem",
    
      "smHeroRegular":  "2rem",
    
      "mdHero":  "2.5rem",
    
      "lgHero":  "3.375rem",
    
      "hugeHero":  "4.5rem",
    
  },

    "AssetFontTreatwellSansWebRegularName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebRegularStyle": "normal",
    "AssetFontTreatwellSansWebRegularWeight": "normal",
    "AssetFontTreatwellSansWebRegularWoff": "assets/fonts/TreatwellSansWeb-Regular/TreatwellSansWeb-Regular.woff",
    "AssetFontTreatwellSansWebRegularWoff2": "assets/fonts/TreatwellSansWeb-Regular/TreatwellSansWeb-Regular.woff2",
    "AssetFontTreatwellSansWebRegularDisplay": "swap",
    "AssetFontTreatwellSansWebRegularItalicName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebRegularItalicStyle": "italic",
    "AssetFontTreatwellSansWebRegularItalicWeight": "normal",
    "AssetFontTreatwellSansWebRegularItalicWoff": "assets/fonts/TreatwellSansWeb-RegularItalic/TreatwellSansWeb-RegularItalic.woff",
    "AssetFontTreatwellSansWebRegularItalicWoff2": "assets/fonts/TreatwellSansWeb-RegularItalic/TreatwellSansWeb-RegularItalic.woff2",
    "AssetFontTreatwellSansWebRegularItalicDisplay": "swap",
    "AssetFontTreatwellSansWebBoldName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebBoldStyle": "normal",
    "AssetFontTreatwellSansWebBoldWeight": "bold",
    "AssetFontTreatwellSansWebBoldWoff": "assets/fonts/TreatwellSansWeb-Bold/TreatwellSansWeb-Bold.woff",
    "AssetFontTreatwellSansWebBoldWoff2": "assets/fonts/TreatwellSansWeb-Bold/TreatwellSansWeb-Bold.woff2",
    "AssetFontTreatwellSansWebBoldDisplay": "swap",
    "AssetFontTreatwellSansWebBoldItalicName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebBoldItalicStyle": "italic",
    "AssetFontTreatwellSansWebBoldItalicWeight": "bold",
    "AssetFontTreatwellSansWebBoldItalicWoff": "assets/fonts/TreatwellSansWeb-BoldItalic/TreatwellSansWeb-BoldItalic.woff",
    "AssetFontTreatwellSansWebBoldItalicWoff2": "assets/fonts/TreatwellSansWeb-BoldItalic/TreatwellSansWeb-BoldItalic.woff2",
    "AssetFontTreatwellSansWebBoldItalicDisplay": "swap",
    "ColorBaseCoral": "#ff5c39",
    "ColorBaseRed": "#dc2222",
    "ColorBaseGold": "#d6cf8d",
    "ColorBaseGreen": "#3ba150",
    "ColorBaseNavy": "#001e62",
    "ColorBasePink": "#ff808b",
    "ColorBaseTeal": "#00a5ad",
    "ColorBaseYellow": "#ffb500",
    "ColorGrey10": "#f8f8f8",
    "ColorGrey30": "#e0e0e0",
    "ColorGrey50": "#bebebe",
    "ColorGrey70": "#707070",
    "ColorGrey90": "#3b3b3b",
    "ColorTransparentLight": "rgba(255,255,255,0.6)",
    "ColorTransparentDark": "rgba(0,0,0,0.6)",
    "ColorWhite": "#fff",
    "ColorRed10": "#fff3f0",
    "ColorRed100": "#961717",
    "ColorCoral10": "#ffeeea",
    "ColorCoral100": "#cb3a29",
    "ColorGold10": "#f7f5e6",
    "ColorGold100": "#726d40",
    "ColorGreen10": "#ecffea",
    "ColorGreen100": "#37824b",
    "ColorNavy10": "#e7efff",
    "ColorNavy100": "#0d1e44",
    "ColorPink10": "#fff0f1",
    "ColorPink100": "#c24353",
    "ColorTeal10": "#e6f9fa",
    "ColorTeal100": "#2f7b84",
    "ColorYellow10": "#fef1d1",
    "ColorYellow100": "#9a6914",
    "ColorBloomBaseNavy800": "#071948",
    "ColorBloomBaseBlue600": "#4036ED",
    "ColorBloomBaseCoral600": "#FF6668",
    "ColorBloomBaseTeal600": "#11C6CF",
    "ColorBloomGreen700": "#008354",
    "ColorBloomGreen400": "#73CFA3",
    "ColorBloomGreen100": "#F1FFF8",
    "ColorBloomBasePurple600": "#8E5AFF",
    "ColorBloomBaseYellow600": "#FFCB4D",
    "ColorBloomBasePink600": "#F89099",
    "ColorBloomGreyNavy800": "#071948",
    "ColorBloomGreyNavy700": "#36456B",
    "ColorBloomGreyNavy600": "#515E7F",
    "ColorBloomGreyNavy500": "#838CA3",
    "ColorBloomGreyNavy400": "#B5BAC8",
    "ColorBloomGreyNavy300": "#E6E8ED",
    "ColorBloomGreyNavy200": "#F3F4F6",
    "ColorBloomGreyNavy100": "#F8F8FA",
    "ColorBloomBlue700": "#2C25A5",
    "ColorBloomBlue400": "#7972F2",
    "ColorBloomBlue200": "#B2AEF7",
    "ColorBloomBlue100": "#EBEAFD",
    "ColorBloomCoral700": "#B24748",
    "ColorBloomCoral400": "#FF9395",
    "ColorBloomCoral200": "#FFC1C2",
    "ColorBloomCoral100": "#FFEFEF",
    "ColorBloomTeal700": "#0B8A90",
    "ColorBloomTeal400": "#58D7DD",
    "ColorBloomTeal200": "#9FE8EB",
    "ColorBloomTeal100": "#E7F9FA",
    "ColorBloomYellow700": "#B28E35",
    "ColorBloomYellow400": "#FFDA82",
    "ColorBloomYellow200": "#FFEAB7",
    "ColorBloomYellow100": "#FFF9ED",
    "ColorBloomPink700": "#B28085",
    "ColorBloomPink400": "#FFCDD1",
    "ColorBloomPink200": "#FFE2E5",
    "ColorBloomPink100": "#FFF7F8",
    "ColorBloomPurple700": "#633EB2",
    "ColorBloomPurple400": "#AF8BFF",
    "ColorBloomPurple200": "#D1BDFF",
    "ColorBloomPurple100": "#F3EEFF",
    "ColorBloomOchre700": "#86640C",
    "ColorBloomOchre400": "#EAB65C",
    "ColorBloomOchre100": "#FDF5EB",
    "ColorBloomRed700": "#D02B0B",
    "ColorBloomRed400": "#FF5641",
    "ColorBloomRed100": "#FDF4F4",
    "ColorFoundationsBlue1000Light": "#051230",
    "ColorFoundationsBlue900Light": "#0A2460",
    "ColorFoundationsBlue800Light": "#0E3591",
    "ColorFoundationsBlue700Light": "#1347C1",
    "ColorFoundationsBlue600Light": "#1859F1",
    "ColorFoundationsBlue500Light": "#467AF4",
    "ColorFoundationsBlue400Light": "#749BF7",
    "ColorFoundationsBlue300Light": "#A3BDF9",
    "ColorFoundationsBlue200Light": "#D1DEFC",
    "ColorFoundationsBlue100Light": "#E8EEFE",
    "ColorFoundationsGrey1000Light": "#1A253D",
    "ColorFoundationsGrey800Light": "#59637A",
    "ColorFoundationsGrey700Light": "#626F8C",
    "ColorFoundationsGrey600Light": "#808BA6",
    "ColorFoundationsGrey500Light": "#949DB2",
    "ColorFoundationsGrey400Light": "#B4BBCA",
    "ColorFoundationsGrey200Light": "#E4E7F0",
    "ColorFoundationsGrey100Light": "#F5F6FA",
    "ColorFoundationsGreen1000Light": "#101F06",
    "ColorFoundationsGreen900Light": "#1F3E0C",
    "ColorFoundationsGreen800Light": "#2F5E12",
    "ColorFoundationsGreen700Light": "#3E7D18",
    "ColorFoundationsGreen600Light": "#4E9C1E",
    "ColorFoundationsGreen500Light": "#6EAF46",
    "ColorFoundationsGreen400Light": "#8EC26E",
    "ColorFoundationsGreen300Light": "#AFD497",
    "ColorFoundationsGreen200Light": "#CFE7BF",
    "ColorFoundationsGreen100Light": "#EFFAE7",
    "ColorFoundationsCoral1000Light": "#300F05",
    "ColorFoundationsCoral900Light": "#611E0A",
    "ColorFoundationsCoral800Light": "#912C0E",
    "ColorFoundationsCoral700Light": "#C23B13",
    "ColorFoundationsCoral600Light": "#F24A18",
    "ColorFoundationsCoral500Light": "#F56E46",
    "ColorFoundationsCoral400Light": "#F79274",
    "ColorFoundationsCoral300Light": "#FAB7A3",
    "ColorFoundationsCoral200Light": "#FCDBD1",
    "ColorFoundationsCoral100Light": "#FEEDE8",
    "ColorFoundationsTeal1000Light": "#022427",
    "ColorFoundationsTeal900Light": "#04474E",
    "ColorFoundationsTeal800Light": "#076B76",
    "ColorFoundationsTeal700Light": "#098E9D",
    "ColorFoundationsTeal600Light": "#0BB2C4",
    "ColorFoundationsTeal500Light": "#3AC1D0",
    "ColorFoundationsTeal400Light": "#6AD0DC",
    "ColorFoundationsTeal300Light": "#99E0E7",
    "ColorFoundationsTeal200Light": "#C9EFF3",
    "ColorFoundationsTeal100Light": "#E0F6F9",
    "ColorFoundationsYellow1000Light": "#2D2105",
    "ColorFoundationsYellow900Light": "#5A4309",
    "ColorFoundationsYellow800Light": "#88640E",
    "ColorFoundationsYellow700Light": "#B58612",
    "ColorFoundationsYellow600Light": "#E2A717",
    "ColorFoundationsYellow500Light": "#E8B945",
    "ColorFoundationsYellow400Light": "#EECA74",
    "ColorFoundationsYellow300Light": "#F3DCA2",
    "ColorFoundationsYellow200Light": "#F9EDD1",
    "ColorFoundationsYellow100Light": "#FCF6E8",
    "ColorFoundationsPink1000Light": "#401417",
    "ColorFoundationsPink900Light": "#6B242A",
    "ColorFoundationsPink800Light": "#95353D",
    "ColorFoundationsPink700Light": "#C04550",
    "ColorFoundationsPink600Light": "#EA5663",
    "ColorFoundationsPink500Light": "#EE7882",
    "ColorFoundationsPink400Light": "#F29AA1",
    "ColorFoundationsPink300Light": "#F7BBC1",
    "ColorFoundationsPink200Light": "#FBDDE0",
    "ColorFoundationsPink100Light": "#FDEEEF",
    "FontFamilyBase": "Arial, Helvetica, sans-serif",
    "FontFamilyTreatwell": "TreatwellSansWeb, Arial, Helvetica, sans-serif",
    "FontStyleNormal": "normal",
    "FontStyleBold": "bold",
    "SizeFontFootnote": "0.75rem",
    "SizeFontFootnoteHeavy": "0.75rem",
    "SizeFontCaption": "0.875rem",
    "SizeFontCaptionHeavy": "0.875rem",
    "SizeFontBody": "1rem",
    "SizeFontBodyHeavy": "1rem",
    "SizeFontSmHeader": "1rem",
    "SizeFontMdHeader": "1.125rem",
    "SizeFontMdHeaderRegular": "1.125rem",
    "SizeFontLgHeader": "1.25rem",
    "SizeFontLgHeaderRegular": "1.25rem",
    "SizeFontXlHeader": "1.5rem",
    "SizeFontHugeHeader": "1.75rem",
    "SizeFontSmHero": "2rem",
    "SizeFontSmHeroRegular": "2rem",
    "SizeFontMdHero": "2.5rem",
    "SizeFontLgHero": "3.375rem",
    "SizeFontHugeHero": "4.5rem",
    "SizeLineHeightFootnote": "1.25rem",
    "SizeLineHeightCaption": "1.25rem",
    "SizeLineHeightBody": "1.5rem",
    "SizeLineHeightSmHeader": "1.5rem",
    "SizeLineHeightMdHeader": "1.5rem",
    "SizeLineHeightMdHeaderRegular": "1.5rem",
    "SizeLineHeightLgHeader": "1.5rem",
    "SizeLineHeightLgHeaderRegular": "1.5rem",
    "SizeLineHeightXlHeader": "1.625rem",
    "SizeLineHeightHugeHeader": "2.125rem",
    "SizeLineHeightSmHero": "2.25rem",
    "SizeLineHeightSmHeroRegular": "2.25rem",
    "SizeLineHeightMdHero": "2.75rem",
    "SizeLineHeightLgHero": "3.875rem",
    "SizeLineHeightHugeHero": "5rem",
    "SpacingXxs": "4",
    "SpacingXs": "8",
    "SpacingSm": "12",
    "SpacingMd": "16",
    "SpacingLg": "24",
    "SpacingXl": "32",
    "SpacingXxl": "40",
  
};